import pkg from "@finn-no/pulse-sdk";
const { trackEvent, trackPageView } = pkg;

/**
 * set_pv01
 *
 * Page View tracking for Seller landing page.
 */
export const trackSellerLandingPageView = () =>
	trackPageView({
		object: {
			id: "set_pv01",
			name: "Seller landing page",
			type: "Page",
		},
	});

/**
 * set_ev01
 *
 * Click event for create item button on Seller landing page.
 */
export const trackClickCreateItemButton = () =>
	trackEvent({
		type: "Click",
		object: {
			id: "set_ev01",
			name: "Create item button",
			type: "UIElement",
		},
	});

/**
 * set_pv02
 *
 * Page View tracking for Finn x Fæbrik collaboration page.
 */

export const trackFaebrikPageView = () =>
	trackPageView({
		object: {
			id: "set_pv02",
			name: "Finn Faebrik collab landing",
			type: "Page",
		},
	});

/**
 * set_ev02
 *
 * Click event for create item button on Finn x Fæbrik collaboration page.
 */
export const trackFaebrikClickCreateItemButton = () =>
	trackEvent({
		type: "Click",
		object: {
			id: "set_ev02",
			name: "Create item button",
			type: "UIElement",
		},
	});
